import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Fab, Menu, MenuItem } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// Floating WhatsApp chat button (replaces Zendesk). The visitor says whether
// they are a candidate or an employer, then WhatsApp opens with that pre-filled.
const options = [
  { label: "I'm a Candidate", text: "Hi, I'm a candidate and I have a question about Direct Expertise." },
  { label: "I'm an Employer", text: "Hi, I'm an employer and I have a question about Direct Expertise." },
];

function WhatsAppButton() {
  const { dropdowndata } = useSelector((state) => state.auth);
  const number = (dropdowndata?.whatsapp_number || "").replace(/\D/g, "");
  const [anchorEl, setAnchorEl] = useState(null);

  if (!number) {
    return null;
  }

  function openChat(text) {
    setAnchorEl(null);
    window.open(`https://wa.me/${number}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  }

  return (
    <>
      <Fab
        aria-label="Chat with us on WhatsApp"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        style={{ position: "fixed", right: 20, bottom: 20, zIndex: 1300, backgroundColor: "#25D366", color: "#fff" }}
      >
        <WhatsAppIcon />
      </Fab>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {options.map((o) => (
          <MenuItem key={o.label} onClick={() => openChat(o.text)}>
            {o.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default WhatsAppButton;
